module.exports = __webpack_public_path__ + "3925212bf51b3ad697ccd4e8de0ca119.png";